// Signin component for user login
import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Signin = ({ onSignIn }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post('http://localhost:3000/api/auth/signin', { email, password });
            const { accessToken } = response.data;
            console.log('Access Token:', response.data.accessToken);
            onSignIn(accessToken);
            localStorage.setItem('token', accessToken); // Store token in local storage
            navigate('/'); // Redirect to homepage
        } catch (error) {
            setError('Invalid credentials');
        }
    };

    return (
        <div className="signin-page">
          <div className="signin-container">
            <div className="signin-form-box">
              <h1><strong>𝒮𝒾𝑔𝓃 𝐼𝓃</strong></h1>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="email"><strong>E-mail</strong></label>
                  <input
                    type="email"
                    id="email"
                    placeholder="Type your e-mail"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="password"><strong>Password</strong></label>
                  <input
                    type="password"
                    id="password"
                    placeholder="Type your password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>
                <button type="submit" className="signin-button"><strong>𝒮𝒾𝑔𝓃 𝐼𝓃</strong></button>
              </form>
            </div>
            <div className="welcome-box">
              <h1><strong>Welcome back!</strong></h1>
              <p>We 've missed you and we are happy to see you again using our website! Sign in to manage your wardrobe and enjoy all our available features.</p>
                <p>You don't have an account? No worries! Click on <span onClick={() => navigate('/signup')}>Sign Up</span></p>
            </div>
          </div>
        </div>
    );
}
    
export default Signin;
    